import { isFunction } from 'lodash';

interface ClickOutsideElement extends HTMLElement {
  clickOutside?: (event: MouseEvent) => void;
  handleMouseDown?: (event: MouseEvent) => void;
}

const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

export default {
  beforeMount(el: ClickOutsideElement, bind: DirectiveBinding<(event: MouseEvent) => void>) {
    if (!bind || !bind.value || !isFunction(bind.value)) {
      throw Error('[v-click-outside] 디렉티브에 함수가 전달되어야 합니다.');
    }

    let mouseDownTarget: EventTarget | null = null;

    el.handleMouseDown = (e: MouseEvent) => {
      mouseDownTarget = e.target;
    };

    el.clickOutside = (event: MouseEvent) => {
      const path = event.composedPath();
      const isClickInside = path.includes(el);
      const isMouseDownInside = mouseDownTarget ? el.contains(mouseDownTarget as Node) : false;

      if (!isClickInside && !isMouseDownInside) {
        bind.value(event);
      }

      mouseDownTarget = null;
    };

    requestAnimationFrame(() => {
      if (el.handleMouseDown && el.clickOutside) {
        window.addEventListener('mousedown', el.handleMouseDown);
        window.addEventListener('click', el.clickOutside);
      }
      if (isTouchDevice() && el.clickOutside) {
        window.addEventListener('touchstart', el.clickOutside);
      }
    });
  },

  beforeUnmount(el: ClickOutsideElement) {
    window.removeEventListener('touchstart', el.clickOutside);
    window.removeEventListener('mousedown', el.handleMouseDown);
    window.removeEventListener('click', el.clickOutside);
  },
};
